import React from 'react';
import './index.less';
import _ from 'lodash';
import { connect } from 'dva';
import Rows from './Rows';
import ABSPanel from '../../ABSPanel';
import ABSLoading from '../../ABSLoading';
import ABSNoContent from '../../ABSNoContent';
import ABSContainer from '../../ABSContainer';
import ABSPagination from '../../ABSPagination';
import commonUtils from '../../../utils/commonUtils';

export interface IABSRowsProps {
  className?: string;
  actionType: string;
  title: string;
  payload: Object;
  model: string;

  loading?: boolean;
  list?: any[];
  renderRow: (item: any) => any;
  renderRightContent: (item: any, key?: number) => any;
  dispatch?: any;
}

export interface IABSRowsState { }

class ABSRows extends React.Component<IABSRowsProps, IABSRowsState> {

  componentDidMount() {
    this.onInit(null);
  }

  componentWillReceiveProps(nextProps: any) {
    const { payload } = nextProps;
    if (!commonUtils.isEqual(this.props.payload, payload)) {
      this.onInit(payload);
    }
  }

  renderList() {
    const { list, loading, renderRow, renderRightContent } = this.props;
    if (!list) {
      return <ABSNoContent />;
    }
    if (loading) {
      return <ABSLoading />;
    }
    return <Rows list={renderRow(list)} renderRightContent={renderRightContent} />;
  }

  render() {
    const { title, actionType, payload, model } = this.props;
    return (
      <div className="abs-list-rows-container">
        <ABSContainer
          className="abs-list-rows-container-warpper"
          removePerfectScrollBar={true}>
          <ABSPanel title={title} removePadding={true} hasBorder={true}>
            {this.renderList()}
          </ABSPanel>
        </ABSContainer>
        <div className="abs-list-container-footer">
          <ABSPagination
            className="abs-deal-list-pagination"
            actionType={actionType}
            payload={payload}
            model={model}
          />
        </div>
      </div>
    );
  }

  onInit = (payload: any) => {
    const { dispatch, payload: payloadP, actionType } = this.props;
    payload = payload || payloadP;
    dispatch({
      type: actionType,
      payload: { ...payload, page_index: 1, page_size: 10 }
    });
  };
}

const mapStateToProps = (state, { model, actionType }) => {
  return {
    loading: state.loading.effects[actionType],
    list: _.get(state, model)
  };
};
export default connect(mapStateToProps)(ABSRows);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSListRowsContainer/ABSRows/index.tsx